export enum AlertType {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success'
}